import {
  ABORTED_REASONS,
  type AbortedReason,
} from '@/features/jobs/lib/job-outcome-options'

const abortedReasonLabels: Record<AbortedReason, string> = Object.fromEntries(
  ABORTED_REASONS.map((reason) => [reason.value, reason.label])
) as Record<AbortedReason, string>

export const formatAbortedReason = (abortedReason: AbortedReason) =>
  abortedReasonLabels[abortedReason]
